import React from 'react'
import TaskDueDate from './TaskDueDate'

const TaskItem = ({ task, onToggleComplete, onDeleteTask, onUpdateTaskDate }) => {
  return (
    <li className={task.completed ? 'completed' : ''}>
      <span onClick={() => onToggleComplete(task.id)}>{task.text}</span>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TaskDueDate taskId={task.id} dueDate={task.dueDate} onUpdateTaskDate={onUpdateTaskDate} />

        <button onClick={() => onDeleteTask(task.id)}>Eliminar</button>
      </div>
    </li>
  )
}

export default TaskItem
